import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_15769_7)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.88306 19.7661C4.43351 19.7661 0 15.3326 0 9.88306C0 4.43351 4.43351 0 9.88306 0C15.3326 0 19.7661 4.43351 19.7661 9.88306C19.7661 15.3326 15.3326 19.7661 9.88306 19.7661ZM9.88306 1.87357C5.4666 1.87357 1.87357 5.4666 1.87357 9.88306C1.87357 14.2995 5.4666 17.8926 9.88306 17.8926C14.2995 17.8926 17.8926 14.2995 17.8926 9.88306C17.8926 5.4666 14.2995 1.87357 9.88306 1.87357ZM23.7073 23.7256C24.0731 23.3598 24.0731 22.7666 23.7073 22.4008L19.5152 18.2087C19.1493 17.8428 18.5562 17.8428 18.1904 18.2087C17.8245 18.5745 17.8245 19.1677 18.1904 19.5335L22.3825 23.7256C22.5654 23.9085 22.8051 24 23.0449 24C23.2847 24 23.5243 23.9085 23.7073 23.7256Z",
			fill: "black"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_15769_7",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgSearchIcon;
